import React from "react";
import TermsConditionsHeader from "./header";
import { useRules } from "../../hooks/apis/main";
import HTMLReactParser from "html-react-parser";

function Terms_conditions_content() {
  const { data, isLoading, error } = useRules();

  if (isLoading) return <div className="active loading">
    <img src="/images/loading.svg" className="img-fluid" />
  </div>;
  if (error) return <p>Error</p>;

  return (
    <div id="terms-conditions">
      <TermsConditionsHeader />
      <div className="terms-conditions-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text">
                  {HTMLReactParser(data.data.page_detail.description)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms_conditions_content;
